import { TFunction } from 'i18next';

export default function transformSubject(t: TFunction<'DetailsLoader'>, subjectDescription: string, freeTextSubject: string): string {
  return freeTextSubject ? `${t('subjectAdditionalTitle')} ${freeTextSubject}` : subjectDescription;
}
